/*
 * Universal Construct — TBI rate ESTIMATOR (standalone, no API).
 * Logica formulei copiată din Calculatorgeneral.js (livrat de TBI), dar cu praguri (brackets)
 * configurabile din theme editor și citite dintr-un <script class="uc-calc-config"> JSON pe pagină.
 * NU se conectează la niciun API; e doar estimare orientativă (ca mockup-ul calculator.html).
 * Independent de fișierele de plată reală (uc-tbi.js / uc-tbi-calculator.js) — nu le atinge.
 */
(function () {
  'use strict';
  if (window.__ucRateCalc) return;   // include o singură dată; init() prinde toate root-urile
  window.__ucRateCalc = true;

  function round2(n) { return Math.round(n * 100) / 100; }

  function computeIRR(cf, guess) {
    var maxIter = 100, prec = 1e-7, rate = (typeof guess === 'number') ? guess : 0.1;
    for (var i = 0; i < maxIter; i++) {
      var npv = 0, d = 0;
      for (var t = 0; t < cf.length; t++) {
        npv += cf[t] / Math.pow(1 + rate, t);
        if (t > 0) d -= t * cf[t] / Math.pow(1 + rate, t + 1);
      }
      if (d === 0) break;
      var nr = rate - npv / d;
      if (Math.abs(nr - rate) < prec) return rate;
      rate = nr;
    }
    return rate;
  }

  function pickBracket(amount, brackets) {
    for (var i = 0; i < brackets.length; i++) {
      var b = brackets[i];
      if (amount >= b.min && amount <= b.max) return b;
    }
    return null;
  }

  function computeDAE(amount, perioada, monthly, b) {
    var cf = [amount];
    if (b.fixed > 0) {
      for (var i = 0; i < b.fixed; i++) cf.push(-(amount + b.commission) / b.fixed);
    } else {
      for (var j = 0; j < perioada; j++) cf.push(-monthly);
    }
    var mr = computeIRR(cf);
    return (Math.pow(1 + mr, 12) - 1) * 100;
  }

  function calc(amount, months, cfg) {
    if (!isFinite(amount) || amount <= 0) return { eligible: false, reason: 'invalid' };
    if (amount < cfg.minAmount) return { eligible: false, reason: 'below', min: cfg.minAmount };
    if (amount > cfg.maxAmount) return { eligible: false, reason: 'above', max: cfg.maxAmount };
    var b = pickBracket(amount, cfg.brackets);
    if (!b) return { eligible: false, reason: 'nobracket' };

    var perioada = b.fixed > 0 ? b.fixed : Math.min(months || cfg.maxMonths, cfg.maxMonths);
    var asig = b.insurance * (amount + b.commission) * perioada;
    var rata, total;
    if (b.fixed > 0) {
      rata = (amount + b.commission) / b.fixed;
      total = amount + b.commission;
    } else {
      var principal = amount + b.commission + asig;
      var r = b.interest / 12;
      if (r === 0) { rata = principal / perioada; }
      else { var x = Math.pow(1 + r, perioada); rata = principal * x * r / (x - 1); }
      total = rata * perioada;
    }
    return {
      eligible: true, amount: amount, perioada: perioada,
      rata: round2(rata), total: round2(total), asigurare: round2(asig),
      interest: b.interest, commission: b.commission,
      dae: round2(computeDAE(amount, perioada, rata, b)),
      variable: b.fixed === 0
    };
  }

  function fmt(n, cur) {
    return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + cur;
  }

  function initRoot(root) {
    if (root.dataset.ucCalcReady === '1') return;
    var cfgEl = root.querySelector('script.uc-calc-config');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    cfg.brackets = (cfg.brackets || []).map(function (b) {
      return { min: +b.min, max: +b.max, interest: (+b.interest) / 100, commission: +b.commission, insurance: (+b.insurance) / 100, fixed: (+b.fixed) || 0 };
    });
    root.dataset.ucCalcReady = '1';

    var amountInput = root.querySelector('[data-amount]');
    var amountRange = root.querySelector('[data-amount-range]');
    var monthsWrap = root.querySelector('[data-months-wrap]');
    var monthsSel = root.querySelector('[data-months]');
    var fixedNote = root.querySelector('[data-fixed-note]');
    var results = root.querySelector('[data-calc-results]');
    var msg = root.querySelector('[data-calc-msg]');
    var out = {
      rata: root.querySelector('[data-out-rata]'),
      perioada: root.querySelector('[data-out-perioada]'),
      total: root.querySelector('[data-out-total]'),
      dae: root.querySelector('[data-out-dae]'),
      asig: root.querySelector('[data-out-asig]'),
      comision: root.querySelector('[data-out-comision]'),
      dobanda: root.querySelector('[data-out-dobanda]')
    };

    function months() { return monthsSel ? parseInt(monthsSel.value, 10) : cfg.defaultMonths; }

    function render() {
      var amount = parseFloat(amountInput.value);
      if (isNaN(amount)) amount = 0;
      var b = pickBracket(amount, cfg.brackets);
      var isFixed = !!(b && b.fixed > 0);
      if (monthsWrap) monthsWrap.style.display = (b && !isFixed) ? '' : 'none';
      if (fixedNote) fixedNote.style.display = isFixed ? '' : 'none';

      var res = calc(amount, months(), cfg);
      if (!res.eligible) {
        if (results) { results.style.opacity = '.35'; results.setAttribute('aria-hidden', 'true'); }
        if (msg) {
          var m = 'Introdu o valoare validă.';
          if (res.reason === 'below') m = 'Suma minimă pentru plata în rate este ' + fmt(res.min, cfg.currency) + '.';
          else if (res.reason === 'above') m = 'Suma maximă online este ' + fmt(res.max, cfg.currency) + '. Pentru sume mai mari, contactează-ne.';
          msg.textContent = m; msg.hidden = false;
        }
        return;
      }
      if (msg) msg.hidden = true;
      if (results) { results.style.opacity = ''; results.removeAttribute('aria-hidden'); }
      if (out.rata) out.rata.textContent = fmt(res.rata, cfg.currency);
      if (out.perioada) out.perioada.textContent = res.perioada + (res.perioada === 1 ? ' lună' : ' luni');
      if (out.total) out.total.textContent = fmt(res.total, cfg.currency);
      if (out.dae) out.dae.textContent = res.dae.toFixed(2) + '%';
      if (out.asig) out.asig.textContent = fmt(res.asigurare, cfg.currency);
      if (out.comision) out.comision.textContent = fmt(res.commission, cfg.currency);
      if (out.dobanda) out.dobanda.textContent = Math.round(res.interest * 100) + '%';
    }

    var raf;
    function schedule() { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(render); }
    if (amountInput) amountInput.addEventListener('input', function () { if (amountRange) amountRange.value = amountInput.value; schedule(); });
    if (amountRange) amountRange.addEventListener('input', function () { if (amountInput) amountInput.value = amountRange.value; schedule(); });
    if (monthsSel) monthsSel.addEventListener('change', render);
    render();
  }

  function init() {
    var roots = document.querySelectorAll('[data-uc-calc]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
